module.exports = __webpack_public_path__ + "static/media/Evan.fa5442c7.jpeg";